export const MENUS = [
    {
      nombre: 'Inicio',
      ruta: '',
      icono: 'dashboard'
    },
    {
      nombre: 'Encuestas',
      ruta: 'encuestas',
      icono: 'create'
    },
    {
      nombre: 'Repositorio',
      ruta: 'repositorio',
      icono: 'attach_file'
    },
    {
      nombre: 'Equipo',
      ruta: 'equipo',
      icono: 'group'
    },
    {
      nombre: 'Eventos',
      ruta: 'eventos',
      icono: 'date_range'
    },
    {
      nombre: 'Sistema',
      ruta: 'sistema',
      icono: 'timeline'
    },
    {
      nombre: 'Contacto',
      ruta: 'contacto',
      icono: 'message'
    },
    {
      nombre: 'Moodle',
      ruta: 'moodle',
      icono: 'library_books'
    },
    // {
    //   nombre: 'Registro',
    //   ruta: 'registro',
    //   icono: 'person_add'
    // },
    // {
    //   nombre: 'Ingreso',
    //   ruta: 'iniciosesion',
    //   icono: 'person'
    // },

]


// WEBPACK FOOTER //
// ./src/app/interfaces/menus.ts